import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Paper,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Tooltip,
} from "@mui/material";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import { isEmpty } from "lodash";
import { DataContext } from "../../../context/DataContext";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { getDepartmentListAsync } from "../../../api/Locations";
import NoData from "../../../components/NoData";
import ListFooter from "../../../components/ui/ListFooter";
import { getTokens } from "../../../theme";

function MainLocations() {
  const [departmentList, setDepartmentList] = useState([]);

  const { reload, setIsLoading, setIsUnautorized, isDarkMode } = useContext(DataContext);
  const t = getTokens(isDarkMode);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getDepartmentListAsync(token);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setDepartmentList(result.data.result);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = departmentList.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        {isEmpty(currentItem) ? (
          <NoData />
        ) : (
          <>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table sx={{ minWidth: 560 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">#</TableCell>
                    <TableCell>Departamento</TableCell>
                    <TableCell align="center">Municipios</TableCell>
                    <TableCell align="center">Ver</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItem.map((row) => (
                    <TableRow
                      key={row.id}
                      hover
                      onClick={() => navigate(`${ruta}/department/${row.id}`)}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell align="center" sx={{ color: "text.disabled", fontWeight: 600 }}>
                        {row.id}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 700, color: "text.primary" }}>{row.name}</TableCell>
                      <TableCell align="center" sx={{ color: "text.secondary" }}>
                        {row.municipalities.length}
                      </TableCell>

                      <TableCell align="center" onClick={(e) => e.stopPropagation()}>
                        <Tooltip title="Ver municipios">
                          <IconButton
                            size="small"
                            sx={{
                              width: 32,
                              height: 32,
                              borderRadius: "9px",
                              border: `1px solid ${t.fieldLine}`,
                              backgroundColor: t.field,
                              color: "primary.main",
                            }}
                            onClick={() => navigate(`${ruta}/department/${row.id}`)}
                          >
                            <VisibilityRoundedIcon sx={{ fontSize: 15 }} />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <ListFooter
              data={departmentList}
              currentCount={currentItem.length}
              indexFirst={indexFirst}
              paginate={paginate}
              itemsperPage={itemsperPage}
              noun="departamentos"
            />
          </>
        )}
      </Paper>
    </div>
  );
}

export default MainLocations;
